// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'DepEd payment upload'"></sub-header>

  <div class="tab-menu">
    <ul class="nav-tabs">
      <li class="active">
        <a data-target="#file-upload" data-toggle="tab">
          <span>File upload</span>
        </a>
      </li>
      <li>
        <a id="tab-header-history" data-target="#history" data-toggle="tab">
          <span>History</span>
        </a>
      </li>
    </ul>
  </div>

  <div class="tab-content">
    <div class="tab-pane active" id="file-upload">
        <h2 class="section-header">Upload DepEd payment file</h2>
        <form name="\$ctrl.depEdForm">
          <table class="misc-transaction__table table">
            <tbody>
            <tr>
              <td>1.</td>
              <td>GL code</td>
              <td>
                <selectize
                  options="\$ctrl.glAccounts"
                  config="\$ctrl.selectConfig"
                  ng-required="true"
                  ng-model="\$ctrl.input.accountCode">
                </selectize>
              </td>
            </tr>
            <tr>
              <td>2.</td>
              <td>Invoice</td>
              <td>
                <input type="text" required ng-model="\$ctrl.input.officialReceipt">
              </td>
              </td>
            </tr>
            <tr>
              <td>3.</td>
              <td>Batch payment file</td>
              <td>
                <file-id-upload
                  ng-change="\$ctrl.parseResult = null"
                  single-file="false"
                  ng-required="true"
                  ng-model="\$ctrl.input.fileIds"
                  max-files="100"
                  name="fileUpload"
                  show-file-name="true"
                  show-remarks="false"
                  enable-webcam="false">
                </file-id-upload>
              </td>
            </tr>
            </tbody>
          </table>

          <div class="buttons summary-actions">
            <button type="button" class="btn btn-warning" ng-click="\$ctrl.reset()">
              Cancel
            </button>
            <button type="button" class="btn btn-success" ng-click="\$ctrl.payBatch()"
                    ng-disabled="\$ctrl.depEdForm.\$invalid">
              Process payment
            </button>
          </div>

          <div class="alert alert--danger" ng-show="\$ctrl.parseResult.formatErrors">
            File has errors: {{\$ctrl.parseResult.formatErrors}}
          </div>

          <div ng-if="\$ctrl.paymentResult">
            <h2 class="section-header">Processing result:</h2>
            <table class="table">
              <thead>
              <tr>
                <th>#</th>
                <th>File</th>
                <th>Has Error</th>
                <th>Message</th>
              </tr>
              </thead>

              <tbody class="tbody">
              <tr ng-repeat="row in \$ctrl.paymentResult">
                <td>{{\$index + 1 }}.</td>
                <td>{{row.fileName}}</td>
                <td>{{row.hasError | prettyBoolean}}</td>
                <td>
                  {{row.statusMessage}}
                  <div ng-if="row.errorRows.length > 1">
                    <br/>
                    <span>Errors:</span>
                    <ul>
                      <li ng-repeat="error in row.errorRows">
                        Row {{error.index}}: {{error.errorMessages}}
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </form>
    </div>

    <div class="tab-pane" id="history">
      <batch-dep-ed-history-list history="\$ctrl.history">
      </batch-dep-ed-history-list>
    </div>

  </div>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/batch/deped/batch-deped-payment.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;